import {
  element,
  elementType,
  func,
  node,
  oneOfType,
  string,
} from "prop-types";
import styled, { css } from "styled-components/macro";
import { darken, lighten, rem } from "polished";

import { colors, fonts } from "../Styles.variables";

const baseStyles = css`
  border: ${rem("1px")} solid;
  border-radius: ${rem("3px")};
  font-weight: ${fonts.weights.bold};
  text-align: center;
  padding: ${rem("10px")};
`;

const errorStyles = css`
  background-color: ${lighten(0.33, colors.red400)};
  border-color: ${darken(0.1, colors.red400)};
  color: ${darken(0.2, colors.red400)};
`;

const infoStyles = css`
  background-color: ${lighten(0.5, colors.blue500)};
  border-color: ${darken(0.1, colors.blue500)};
  color: ${darken(0.2, colors.blue500)};
`;

const successStyles = css`
  background-color: ${lighten(0.5, colors.green400)};
  border-color: ${darken(0.1, colors.green400)};
  color: ${darken(0.2, colors.green400)};
`;

const warningStyles = css`
  background-color: ${lighten(0.3, colors.orange400)};
  border-color: ${darken(0.1, colors.orange400)};
  color: ${darken(0.2, colors.orange400)};
`;

const Alert = styled(({ children, tag: Component, type, ...rest }) => (
  <Component {...rest}>{children}</Component>
))`
  ${baseStyles};

  ${({ type }) => {
    switch (type) {
      case "error":
        return errorStyles;
      case "warning":
        return warningStyles;
      case "success":
        return successStyles;
      case "info":
      default:
        return infoStyles;
    }
  }}
`;

Alert.propTypes = {
  children: node,
  tag: oneOfType([element, elementType, func, string, node]),
  type: string,
};

Alert.defaultProps = {
  tag: "div",
};

export default Alert;
